import { render, staticRenderFns } from "./games.vue?vue&type=template&id=2ff7e1a2&scoped=true"
import script from "./games.vue?vue&type=script&lang=js"
export * from "./games.vue?vue&type=script&lang=js"
import style0 from "./games.vue?vue&type=style&index=0&id=2ff7e1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff7e1a2",
  null
  
)

export default component.exports